import Phaser from "phaser";
import { registerDesignTextures } from "../design/textures.ts";

export class BootScene extends Phaser.Scene {
  public constructor() {
    super("boot");
  }

  public async create(): Promise<void> {
    await registerDesignTextures(this);
    document.body.classList.add("ready");
    this.scene.start("village");
  }
}
